import React, { useState } from "react";
import { useField } from "react-final-form";
import { Modal, Toggle } from "@truevault/aquilo";
import { ConsentSettingRow } from "../../../consentBanner/ConsentSettingRow";

export const ConsentBannerAllowCSSOverridesRow = () => {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const { input } = useField<boolean>("allowCSSOverrides", { type: "checkbox" });
  const enabled = Boolean(input.checked);

  const handleCancel = () => {
    setShowWarningModal(false);
  };

  return (
    <>
      <ConsentSettingRow
        title="Custom styles"
        helpText="Let your developers restyle the banner with your own CSS."
      >
        <div className="flex items-center gap-[10px]">
          <Toggle
            checked={enabled}
            label="Allow custom styles"
            onChange={(checked) => {
              // Turning this on needs an explicit acknowledgement first.
              if (checked) {
                setShowWarningModal(true);
              } else {
                input.onChange(false);
              }
            }}
          />
          <span className="text-[14px] font-medium leading-[20px] text-neutral-800">
            {enabled ? "On" : "Off"}
          </span>
        </div>
      </ConsentSettingRow>

      {showWarningModal && (
        <Modal
          title="A note about consent banner styles"
          body={
            <>
              <p className="mb-md">
                This lets your brand take full control over the style of your banner. Only enable it
                if your team has applied custom CSS to your website to further customize the look of
                your consent banner.
              </p>
              TrueVault's consent banners are configured to help you comply with privacy laws and to
              avoid employing{" "}
              <a
                href="https://knowledge.truevault.com/article/256-cookie-banner-design"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-600 hover:text-primary-700 underline"
              >
                dark patterns
              </a>
              , which can be considered a privacy violation. If you choose to alter the design of
              your banner in a way that falls outside of our recommendations, you assume all risk of
              any enforcement or legal action that occurs as a result.
            </>
          }
          alignText="left"
          closeButton={true}
          onClose={handleCancel}
          firstButton="Cancel"
          secondButton="I understand"
          firstButtonColor="tertiary"
          secondButtonColor="primary"
          alignButton="right"
          onFirstButtonClick={handleCancel}
          onSecondButtonClick={() => {
            input.onChange(true);
            setShowWarningModal(false);
          }}
          showOverlay={true}
          closeOnOverlayClick={false}
        />
      )}
    </>
  );
};
